/** In this file entities are declared */
import { BASE_URL } from "../../request";
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../utils";
import { tickerValidator } from "../../globalVariables";

const ModuleDefinition = {
  /** name is the title */
  name: "Modificaciones",
  /** entityName is used to link with the constants */
  entityName: "modification",
  restConfig: {
    baseURL: `${BASE_URL}`,
    create: {
      url: ({ propertyTicker }) => `api/backoffice/${propertyTicker}/modificationpolicies`,
      method: "post",
      resetCache: true,
    },
    update: {
      url: ({ propertyTicker }) => `api/backoffice/${propertyTicker}/modificationpolicies`,
      method: "put",
      resetCache: true,
    },
    fetch: {
      url: ({ propertyTicker, hotelTicker, id }) =>
        `/api/backoffice/${propertyTicker || hotelTicker}/modificationpolicies/${id ? id : ""}`,
      method: "get",
    },
    delete: {
      url: ({ propertyTicker, id }) =>
        `api/backoffice/${propertyTicker}/modificationpolicies/${id}`,
      method: "delete",
      resetCache: true,
    },
  },
  allowClone: true,
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "Translations",
    widget: "translations",
    entityProperty: "translations",
  },
  fields: {
    /** Here are te entities used in the lists, Order is important */
    /** fieldName: this is used like the id container of the properties */
    /** displayName: this is the title rendered */
    list: [
      {
        fieldName: "ticker",
        displayName: "Policy ticker",
      },
      {
        fieldName: "conditionRates",
        displayName: "Conditions",
      },
      {
        fieldName: "canModifyDates",
        displayName: "Modify dates",
      },
      {
        fieldName: "canModifyAccommodations",
        displayName: "Modify accommodation",
      },
    ],
    /** Here is the entity used in the forms, Order is important */
    /** all the properties can be found in app/components/CRUD/Common, at the corresponding js file */
    /** fieldName: is like the id in html, it must be unique among the attributes */
    /** widget: is used to render the kind of interaction the user will have, a complete list can be found in component/CRUD/Common */
    /** displayName: The text that introduces the widget */
    /** defaultValue: The default value of the widget */
    /** optionDisplay: An object that containes objects with the option at the select */
    /*
    {
      "id": 1,
      "propertyTicker": "demo_urbano",
      "ticker": "mainPolicyUpdated",
      "canModifyDates": false,
      "datesMinRelease": {
        "duration": 12.0,
        "chronoUnit": "DAYS"
      },
      "datesModificationRestrictionType": "AMOUNT_GTE",
      "canModifyAccommodations": false,
      "accommodationMinRelease": {
        "duration": 17.0,
        "chronoUnit": "DAYS"
      },
      "accommodationModificationRestrictionType": "NO_RESTRICTION",
      "conditionRates": ["cgi", "nro"]
    }
    */
    form: [
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "hotelTicker",
        displayName: "hotel Ticker",
        widget: "hidden",
      },
      {
        fieldName: "propertyTicker",
        displayName: "property Ticker",
        widget: "hidden",
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
        readOnly: true,
        widget: "input",
        className: "tickerInput",
      },
      {
        fieldName: "rateTypeSection",
        displayName: "Modify dates",
        widget: "section",
      },

      {
        fieldName: "canModifyDates",
        widget: "singleSwitch",
        displayName: "Enabled",
        defaultValue: false,
      },
      {
        fieldName: "datesModificationRestrictionType",
        widget: "selector",
        displayName: "Only if:",
        className: "datesSelector",
        optionDisplay: {
          AMOUNT_AND_STAY_GTE: {
            label: "It equals or exceeds the duration of the stay and total amount",
          },
          STAY_GTE: {
            label: "Se iguale o supere la duración de la estancia",
          },
          AMOUNT_GTE: {
            label: "Equal or exceed the duration of the stay",
          },
          NO_RESTRICTION: {
            label: "Total freedom in exchange for dates.",
          },
        },
        defaultValue: "NO_RESTRICTION",
      },
      {
        fieldName: "datesMinRelease",
        displayName: "Minimum advance for modifications (days):",
        widget: "input",
        defaultValue: 0,
      },
      {
        fieldName: "accommodationSection",
        displayName: "Modify accommodations",
        widget: "section",
      },
      {
        fieldName: "canModifyAccommodations",
        widget: "singleSwitch",
        displayName: "Enabled",
        defaultValue: false,
      },
      {
        fieldName: "accommodationModificationRestrictionType",
        displayName: "Only if:",
        widget: "selector",
        optionDisplay: {
          AMOUNT_GTE: {
            label: "The stay amount is the same or greater",
          },
          NO_RESTRICTION: {
            label: "Total freedom for changing stay dates",
          },
        },
        defaultValue: "NO_RESTRICTION",
      },
      {
        fieldName: "accommodationMinRelease",
        displayName: "Minimum advance for modifications (days):",
        widget: "input",
        defaultValue: 0,
      },
      {
        fieldName: "canChangeConditions",
        widget: "singleSwitch",
        displayName: "Enabled",
        defaultValue: true,
      },
      {
        fieldName: "conditionSection",
        displayName: "Applies to the conditions:",
        widget: "section",
      },
      {
        fieldName: "conditionRates",
        widget: "multicheckbox",
        visible: ({ formValues, entity }) => entity.ticker !== "DEFAULT",
      },
    ],
  },
  validation: {
    id: {
      type: "String",
      constraints: {},
    },
    propertyTicker: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    ticker: tickerValidator,
    canModifyDates: {
      type: "Boolean",
      constraints: {},
    },
    datesMinRelease: {
      type: "Number",
      constraints: {
        numericality: {
          onlyInteger: true,
          greaterThanOrEqualTo: 0,
        },
      },
      defaultValue: 0,
    },
    datesModificationRestrictionType: {
      type: "Enum",
      constraints: {
        inclusion: {
          /** The values inside within and default value must be the same name as the property*/
          within: ["AMOUNT_AND_STAY_GTE", "STAY_GTE", "AMOUNT_GTE", "NO_RESTRICTION"],
        },
      },
      defaultValue: "NO_RESTRICTION",
    },
    canModifyAccommodations: {
      type: "Boolean",
      constraints: {},
    },
    accommodationMinRelease: {
      type: "Number",
      constraints: {
        numericality: {
          onlyInteger: true,
          greaterThanOrEqualTo: 0,
        },
      },
    },
    accommodationModificationRestrictionType: {
      type: "Enum",
      constraints: {
        inclusion: {
          within: ["AMOUNT_GTE", "NO_RESTRICTION"],
        },
      },
      defaultValue: "NO_RESTRICTION",
    },
    conditionRates: {
      type: "Array",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
